// TWP FLEX SCREEN ORDER — CSV EXPORT
//
// Windows skipped from flex screen export:
//   1. 3LHS / 3HS  — 3-Lite Horizontal Slider (no screens ordered for these)
//   2. CSMT with Dk Woodgrain color — interior casements don't get flex screens

function shouldSkipFlexScreen(win) {
  const type  = (win.type  || '').toUpperCase().trim();
  const color = (win.color || win.frameColor || '').toLowerCase();

  // 3-Lite Horizontal Slider — never gets flex screens
  if (type === '3LHS' || type === '3HS') return true;

  // Casement with dark woodgrain — interior unit, no flex screen
  if (type === 'CSMT' && color.includes('woodgrain')) return true;

  return false;
}

function meshCode(m){if(!m)return 'STD';const s=m.toLowerCase();if(s.includes('solar'))return 'Solar';if(s.includes('pet'))return 'Pet';if(s.includes('no')&&s.includes('see'))return 'NoSeeUm';return 'STD';}
function screenCode(s){if(!s)return 'FS';const t=s.toLowerCase();if(t.includes('half')||t==='hs')return 'HS';return 'FS';}
function todayMMDDYYYY(){const d=new Date();return String(d.getMonth()+1).padStart(2,'0')+String(d.getDate()).padStart(2,'0')+d.getFullYear();}
function twoWeeksFromToday(){const d=new Date();d.setDate(d.getDate()+14);return `${d.getMonth()+1}/${d.getDate()}/${d.getFullYear()}`;}
function downloadCSV(csv,filename){const blob=new Blob([csv],{type:'text/csv;charset=utf-8;'});const url=URL.createObjectURL(blob);const a=document.createElement('a');a.href=url;a.download=filename;document.body.appendChild(a);a.click();document.body.removeChild(a);URL.revokeObjectURL(url);}

export function exportFlexScreenOrderAsCSV(jobs, dateFrom, dateTo, repairItems = []) {
  const po         = `TWP${todayMMDDYYYY()}`;
  const poRequired = twoWeeksFromToday();
  const rows       = [];

  jobs.forEach(job => {
    const customerName = (job.customerName || '').trim();
    const woNumber     = (job.woNumber     || '').trim();

    (job.calculatedWindows || []).forEach(win => {
      // Skip 3LHS and dark woodgrain casements
      if (shouldSkipFlexScreen(win)) return;

      if (!win.flexScreen) return;
      const fs = win.flexScreen;

      rows.push([
        po,
        poRequired,
        fs.qty ?? win.qty ?? 1,
        fs.width  ?? '',
        fs.height ?? '',
        meshCode(fs.meshType),
        screenCode(fs.screenType ?? fs.screenSize),
        '',
        '',
        (win.label || '').trim(),
        woNumber,
        customerName,
      ]);
    });
  });

  // Repair / walk-in items — always included regardless of type
  (repairItems || []).filter(r => r.width && r.height).forEach(r => {
    rows.push([
      po,
      poRequired,
      r.qty || 1,
      r.width,
      r.height,
      meshCode(r.meshType),
      screenCode(r.screenType ?? r.screenSize),
      '',
      '',
      r.label || '',
      '',
      '',
    ]);
  });

  if (!rows.length) {
    alert('No flex screen items found in the selected date range.');
    return;
  }

  const header = [
    'PO#', 'PO Required Date', 'Quantity',
    'Screen Width', 'Screen Height', 'Mesh Type', 'Screen Type',
    'Adaptor Length', 'Adaptor Color',
    'Label Field 1', 'Label Field 2', 'Label Field 3',
  ];

  const lines = [
    header.join(','),
    ...rows.map(row =>
      row.map(cell => {
        const s = String(cell ?? '');
        return s.includes(',') || s.includes('"') ? `"${s.replace(/"/g, '""')}"` : s;
      }).join(',')
    ),
  ];

  const cd = d => d.replace(/[\s,/]/g, '-');
  downloadCSV(lines.join('\n'), `TWP_FlexScreen_${cd(dateFrom)}_to_${cd(dateTo)}.csv`);
}